<template>
	<div class="header-filter">
		<div class="header-filter-form">
			<div class="header-filter-form-row" :class="{ 'show-label': showLabel }">
				<template v-if="showLabel">
					<template v-for="(item, index) in filterList">
						<div
							class="item label-col"
							v-if="index < showLength || showMore"
							:key="index"
							:class="{ double: item.type === 'selectAndDataPicker' }"
						>
							<div :style="{ width: labelWidth, textAlign: labelAlign }">
								{{ item.label }}
							</div>
							<render-form
								:value="value[item.key]"
								@input="(value) => handleInput(value, item.key)"
								@search="handleSearch"
								v-bind="item"
							/>
						</div>
					</template>
				</template>

				<template v-else>
					<template v-for="(item, index) in filterList">
						<render-form
							v-if="index < showLength || showMore"
							class="item"
							:class="{ double: item.type === 'selectAndDataPicker' }"
							:key="index"
							:value="value[item.key]"
							@input="(value) => handleInput(value, item.key)"
							@search="handleSearch"
							v-bind="item"
						/>
					</template>
				</template>

				<div class="operate" :class="operateAlign">
					<el-button plain size="small" @click="handleReset" icon="el-icon-refresh" class="reset-btn">
						{{ $t("reset") }}
					</el-button>
					<el-button size="small" type="primary" icon="el-icon-search" @click="handleSearch">
						{{ $t("query") }}
					</el-button>
					<div class="operate-more" @click="handleMore" v-if="filterList.length > showLength">
						{{ showMore ? $t("packUp") : $t("more") }}
						<i class="el-icon-arrow-down" :class="{ active: showMore }"></i>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
/**
 * @description: 筛选组件
 * @param {Array} filterList 筛选表单
 * @param {Object} value 筛选表单值 双向绑定
 * @param {Number} showLength 显示筛选条件数量，默认7，超过7个显示更多
 * @param {Boolean} defaultShowMore 更多按钮默认显示状态
 * @param {Boolean} showLabel 是否显示label
 * @param {String} labelWidth label宽度
 * @param {String} labelAlign label对齐方式
 * @param {String} operateAlign 操作按钮对齐方式
 *
 * @event handleSearch 查询事件
 * @event handleMore 点击更多触发事件
 * @event handleClear 重置事件
 */

import RenderForm from "./components/RenderForm";

export default {
	name: "XbdFilter",
	components: {
		RenderForm
	},
	props: {
		filterList: {
			type: Array,
			default: () => []
		},
		showLength: {
			type: Number,
			default: 7
		},
		value: {
			type: Object,
			default: () => ({})
		},
		defaultShowMore: {
			type: Boolean,
			default: false
		},
		/**
		 * 是否需要label
		 */
		showLabel: {
			type: Boolean,
			default: false
		},
		labelWidth: {
			type: String,
			default: "80px"
		},
		labelAlign: {
			type: String,
			default: "right"
		},
		operateAlign: {
			type: String,
			default: "right"
		}
	},
	data() {
		return {
			showMore: this.defaultShowMore
		};
	},
	methods: {
		handleSearch() {
			this.$emit("handleSearch", this.value);
		},
		handleReset() {
			this.$emit("input", {});
			this.handleSearch();
			this.$emit("handleClear");
		},
		handleInput(value, key) {
			const newValue = {
				...this.value,
				[key]: value
			};

			this.$emit("input", newValue);
		},
		handleMore() {
			this.showMore = !this.showMore;
			this.$emit("handleMore", this.showMore);
		}
	}
};
</script>

<style scoped lang="scss">
.header-filter {
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;

	&-form {
		width: 100%;
		display: flex;
		flex-wrap: wrap;
		flex-direction: row;

		&-row {
			width: 100%;
			box-sizing: border-box;
			display: grid;
			grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
			gap: 16px 32px; /* 如果你想在元素之间添加一些间隙 */

			&.show-label {
				grid-template-columns: repeat(auto-fill, minmax(330px, 1fr));
			}

			.item {
				font-size: 14px;
				min-width: 250px;
			}

			.label-col {
				display: flex;
				align-items: center;

				> :first-child {
					margin-right: 8px;
					color: #2d3743;
				}

				> :last-child {
					flex: 1;
				}
			}

			.double {
				grid-column: span 2;
			}

			.operate {
				display: flex;

				&.left {
					justify-content: flex-start;
				}

				&.center {
					grid-column-end: -1;
					justify-content: center;
				}

				&.right {
					grid-column-end: -1;
					justify-content: flex-end;
				}

				&-more {
					height: 32px;
					margin-left: 8px;
					display: flex;
					align-items: center;
					justify-content: center;
					color: #3c424d;
					font-family: "PingFang SC";
					font-size: 14px;
					font-style: normal;
					font-weight: 400;
					line-height: 22px;
					cursor: pointer;

					&:hover {
						color: #095ce6;

						> i {
							color: #095ce6;
						}
					}

					> i {
						color: #9095a3;
						font-size: 12px;
						margin-left: 4px;
						transition: all 0.3s ease 0s;

						&.active {
							transform: rotate(180deg);
						}
					}
				}
			}
		}
	}
}
</style>
